import React from "react";

const formatSlashDate = (value) => {
  if (!value) return "";
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const [y, m, d] = value.split("-");
  return `${d}-${m}-${y}`;
};

/**
 * Front + back wallet-card preview matching the TUV PAK crane operator reference.
 */
const CraneOperatorDocument = ({ doc }) => {
  if (!doc) return null;
  const assetsBase = `${doc.assetsBase || ""}/crane-operator`;
  const rootAssets = doc.assetsBase || "";
  const certNo = String(doc.report_no || "").trim();
  const title = String(doc.report_title || "CRANE OPERATOR").toUpperCase();
  const photoUrl = doc.examPhotoUrl || "";
  const sealUrl = doc.sealUrl || `${assetsBase}/seal.png`;
  const logoUrl = `${assetsBase}/logo-tuvpak.png`;
  const bgFront = `${assetsBase}/bg-front.png`;
  const bgBack = `${assetsBase}/bg-back.png`;
  const headerBand = `${assetsBase}/header-band.png`;
  const iconMail = `${assetsBase}/icon-mail.png`;
  const iconWww = `${assetsBase}/icon-www.png`;
  const signatureUrl = doc.approvedSignatureUrl || `${assetsBase}/signature-default.png`;

  const details = [
    ["NAME", doc.holder_name],
    ["ID NO.", doc.id_no],
    ["ISSUED", formatSlashDate(doc.issue_date)],
    ["EXPIRY", formatSlashDate(doc.expire_date)],
    ["COMPANY", doc.company],
    ["PROJECT", doc.project],
  ];

  return (
    <div className="cc-op-sheet">
      <div className="cc-op-card-face cc-op-card-face--front" style={{ backgroundImage: `url(${bgFront})` }}>
        <div className="cc-op-card-face__header" style={{ backgroundImage: `url(${headerBand})` }}>
          <div className="cc-op-card-face__brand-text">
            <strong>TUV PAK INSPECTION &amp;</strong>
            <strong>CERTIFICATION</strong>
          </div>
          <img className="cc-op-card-face__logo" src={logoUrl} alt="TUV PAK" onError={(e) => { e.currentTarget.src = `${rootAssets}/logo.jpg`; }} />
        </div>
        <div className="cc-op-card-face__body">
          <div className="cc-op-card-face__left">
            <h2 className="cc-op-card-face__title">{title}</h2>
            <dl className="cc-op-card-face__details">
              {details.map(([label, value]) => (
                <div key={label}><dt>{label}:</dt><dd>{value || "—"}</dd></div>
              ))}
            </dl>
          </div>
          <div className="cc-op-card-face__right">
            <div className="cc-op-card-face__certno">{certNo}</div>
            <div className="cc-op-card-face__photo">
              {photoUrl ? <img src={photoUrl} alt="Operator" /> : <span>ADD PICTURE</span>}
              {signatureUrl && <img className="cc-op-card-face__sig" src={signatureUrl} alt="" />}
            </div>
            <img className="cc-op-card-face__seal" src={sealUrl} alt="" />
          </div>
        </div>
      </div>

      <div className="cc-op-card-face cc-op-card-face--back" style={{ backgroundImage: `url(${bgBack})` }}>
        <div className="cc-op-card-face__back-top">
          <div>
            <div>TRAINED BY: {(doc.trained_by_name || doc.inspected_by_name || "—").toUpperCase()}</div>
            <div>APPROVED BY: {(doc.approved_by_name || "—").toUpperCase()}</div>
          </div>
          <div className="cc-op-card-face__certno">{certNo}</div>
        </div>
        <div className="cc-op-card-face__back-mid">
          <img className="cc-op-card-face__seal-lg" src={sealUrl} alt="" />
          <div className="cc-op-card-face__level">
            <span>LEVEL</span>
            <strong>{doc.level || "N/A"}</strong>
          </div>
          <div className="cc-op-card-face__back-right">
            <img className="cc-op-card-face__logo" src={logoUrl} alt="TUV PAK" />
            {doc.qrDataUrl && <img className="cc-op-card-face__qr" src={doc.qrDataUrl} alt="QR" />}
          </div>
        </div>
        <div className="cc-op-card-face__footer">
          <span><img src={iconMail} alt="" /> info@tuvpak.com</span>
          <span><img src={iconWww} alt="" /> www.tuvpak.com</span>
        </div>
      </div>
    </div>
  );
};

export default CraneOperatorDocument;
